import React, {PureComponent} from "react";
import {fromLonLat} from "ol/proj";
import Map from "ol/Map";
import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import View from "ol/View";
import {subscribeToMapInfo} from "../functions/api";
import $ from "jquery";
import Overlay from "ol/Overlay";
import Feature from "ol/Feature";
import LineString from "ol/geom/LineString";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import map from "async/map";

import {withCookies} from "react-cookie";

let mapWindow = null;

// Create a pattern, offscreen
const patternCanvas = document.createElement("canvas");
const patternContext = patternCanvas.getContext("2d");
// Give the pattern a width and height of 50
patternCanvas.width = 50;
patternCanvas.height = 50;

class Track extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            mapWindowOpen: false,
        };

        this.setupMap = this.setupMap.bind(this);
        this.popoutTrack = this.popoutTrack.bind(this);
        this.checkSessionStatusChanged = this.checkSessionStatusChanged.bind(this);
        this.updateFlagPolylines = this.updateFlagPolylines.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {
        setTimeout(() => {
            this.setupMap();
        }, 1500);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.toggleCarList !== this.props.toggleCarList) {
            setTimeout(() => {
                this.dash_map.updateSize();
                console.log("[TRACK COMPONENT] Map resized!");
            }, 1000);
        }
        if (prevProps.activeTab !== this.props.activeTab) {
            if (this.props.activeTab === 0) {
                setTimeout(() => {
                    this.dash_map.updateSize();
                }, 500);
            }
        }
        if (JSON.stringify(prevProps.sessionFlagStatus) !== JSON.stringify(this.props.sessionFlagStatus) && this.dash_map !== undefined) {
            if (this.props.sessionFlagStatus && this.props.sessionFlagStatus.length > 0) {
                this.updateFlagPolylines();
            }
        }
    }

    componentWillUnmount() {
        subscribeToMapInfo(this.props.eventID, true, null);
    }

    /* HANDLERS */
    updateFlagPolylines() {
        // check if there are active layers
        this.dash_map.getLayers().forEach((layer) => {
            if (layer && layer.get("name") && layer.get("name") === "sectors") {
                this.dash_map.removeLayer(layer);
            }
        });
        let featureArr = [];

        for (let i = 0; i < this.props.marshallPosts.length; i++) {
            if (this.props.sessionFlagStatus[i] !== null) {
                let coords = [];
                for (let c = 0; c < this.props.marshallPosts[i].polyline.length; c++) {
                    coords.push(
                        fromLonLat([
                            this.props.marshallPosts[i].polyline[c].lng,
                            this.props.marshallPosts[i].polyline[c].lat]
                        )
                    );
                }

                let style = null;
                if (this.props.sessionFlagStatus[i].second_color) {
                    let color1 = this.props.sessionFlagStatus[i].first_color;
                    let color2 = this.props.sessionFlagStatus[i].second_color;
                    let numberOfStripes = 50;
                    for (let x = 0; x < numberOfStripes * 2; x++) {
                        let thickness = 300 / numberOfStripes;
                        patternContext.beginPath();
                        patternContext.strokeStyle = x % 2 ? color1 : color2;
                        patternContext.lineWidth = thickness;
                        patternContext.lineCap = "round";

                        patternContext.moveTo(x * thickness + thickness / 2 - 300, 0);
                        patternContext.lineTo(x * thickness + thickness / 2, 300);
                        patternContext.stroke();
                    }

                    // Create our primary canvas and fill it with the pattern
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");
                    const pattern = ctx.createPattern(patternCanvas, "repeat");
                    ctx.fillStyle = pattern;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);

                    style = new Style({
                        stroke: new Stroke({
                            lineCap: "round",
                            lineJoin: "round",
                            width: 9,
                            color: pattern,
                        }),
                    });
                } else {
                    style = new Style({
                        stroke: new Stroke({
                            lineCap: "round",
                            lineJoin: "round",
                            width: 9,
                            color: this.props.sessionFlagStatus[i].first_color,
                        }),
                    });
                }
                let feature = new Feature({
                    geometry: new LineString(coords),
                    name: "Line",
                });
                feature.setStyle(style);
                featureArr.push(feature);
            }
        }
        let layerLines = new VectorLayer({
            name: "sectors",
            className: "dash_map_sectors",
            source: new VectorSource({
                features: featureArr
            }),
        });
        this.dash_map.addLayer(layerLines);
    }

    /* GET DATA */
    checkSessionStatusChanged(newStatus) {
        let flag = false;
        for (let i = 0; i < this.state.sessionFlagIDs.length; i++) {
            if (this.state.sessionFlagIDs[i] !== newStatus[i]) {
                flag = true;
                break;
            }
        }
        return flag;
    }

    setupMap() {
        this.dash_map = new Map({
            target: "dash_map",
            layers: [
                new TileLayer({
                    source: new XYZ({
                        attributions: 'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer">ArcGIS</a>',
                        url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                    })
                }),
            ],
            view: new View({
                center: fromLonLat([this.props.mapCenterLng, this.props.mapCenterLat]),
                zoomFactor: 1.1,
                zoom: $(window).width() < 1200 ? this.props.mapZoomLevel - 1 : this.props.mapZoomLevel,
                maxZoom: 141,
                rotation: this.props.mapRotation,
            }),
            loadTilesWhileAnimating: true,
            loadTilesWhileInteracting: true,
        });

        if (this.props.sessionFlagStatus && this.props.sessionFlagStatus.length > 0) {
            this.updateFlagPolylines();
        }

        // Subscribe to map feed
        subscribeToMapInfo(this.props.eventID, false, (error, coords) => {
            const helper = this;
            map(coords, function (coord, callback) {
                // Check if there"s already a marker for this car
                let marker = null;
                let iconColor = "#000000";
                let flagColor = "#FFFFFF";
                let flagTextColor = "#000000";
                let flagTextSize = "12px";

                if (coord.lng !== 0 && coord.lat !== 0) {

                    if (helper.dash_map.getOverlayById(coord.cid) || [2, 3].includes(parseInt(coord.rsi))) {
                        try {
                            marker = helper.dash_map.getOverlayById(coord.cid);
                            if ([2, 3].includes(parseInt(coord.rsi))) {
                                if (marker !== null) helper.dash_map.removeOverlay(marker);
                            } else {

                                marker.setPosition(fromLonLat([coord.lng, coord.lat]));

                                if (parseInt(coord.cid) === parseInt(helper.props.carID)) {
                                    iconColor = "#b10c0e";
                                    flagColor = "#b10c0e";
                                    flagTextColor = "#FFFFFF";
                                    flagTextSize = "15px";
                                }

                                document.getElementById(coord.cid).style.color = iconColor;
                                document.getElementById("flag_" + coord.cid).style.background = flagColor;
                                document.getElementById("flag_" + coord.cid).style.color = flagTextColor;
                                document.getElementById("flag_" + coord.cid).style.fontSize = flagTextSize;
                            }
                        } catch (e) {
                            console.log(e);
                        }

                    } else {

                        const innerDiv = $('' +
                            '<div id="car_id_marker_' + coord.cid + '">' +
                            '   <p id="flag_' + coord.cid + '" class="carPinText">#' + coord.cln + '</p>' +
                            '   <span class="fa-stack carPin">' +
                            '       <i id="' + coord.cid + '" class="fa fa-circle fa-stack-2x" style="line-height: inherit;color: ' + iconColor + '"/><i class="fa fa-car fa-stack-1x fa-inverse" style="font-size:15px;margin:inherit"/>' +
                            '   </span>' +
                            '</div>').get(0);

                        marker = new Overlay({
                            id: coord.cid,
                            element: innerDiv,
                            position: fromLonLat([coord.lng, coord.lat]),
                            offset: [0, 10],
                            positioning: "bottom-center",
                            className: "animation_move"
                        });

                        helper.dash_map.addOverlay(marker);

                        $("#car_id_marker_" + coord.cid).click((e) => {
                            try {
                                const carID = parseInt(e.currentTarget.id.split("_")[3]);
                                console.log("[TRACK COMPONENT] CLICKED ON #" + carID);
                                // Find out if it is own team
                                for (let i = 0; i < helper.props.carList.length; i++) {
                                    if (helper.props.carList[i].id === carID) {
                                        helper.props.updateCurrentCarID(carID, helper.props.carList[i].isOwnTeam, null);
                                        break;
                                    }
                                }
                            } catch (e) {
                                console.error(e);
                            }
                        });
                    }
                }
                callback(null, "done");
            }, function (err, result) {
                if (err) {
                    console.log("[TRACK COMPONENT] error processing coords obj", err);
                }
            });
        });
    }

    /* POPOUT METHODS */
    popoutTrack() {
        let params = "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=1000,height=500,left=100,top=200";
        mapWindow = window.open("expandMap/" + this.props.eventID + "/" + this.props.sessionID + "/" + (this.props.carID !== null ? this.props.carID : -1) + "/" + $(window).width(), "map", params);
        console.log("[TRACK COMPONENT] POPOUT opened");
        $("#dash_map").fadeOut();
        this.setState({mapWindowOpen: true});

        mapWindow.onbeforeunload = () => {
            console.log("[TRACK COMPONENT] POPOUT closed");
            $("#dash_map").fadeIn();
            this.setState({mapWindowOpen: false});
            return null;
        };
    }

    /* RENDER */
    render() {
        return (
            <>
                <div style={{position: "absolute", top: 1, right: 20, padding: 5, zIndex: 10}}>
                    {!this.props.isGuest ? (
                        <button
                            type={"button"}
                            data-tip={true}
                            data-for={"track"}
                            className={"btn btn-primary button"}
                            onClick={this.popoutTrack}
                            style={{float: "right", padding: 10}}
                        >
                            <i className={"fas fa-expand-arrows-alt App_buttonContainer_icons"}/>
                        </button>
                    ) : null}
                </div>
                <div id={"dash_map"}/>
            </>
        );
    }
}

export default withCookies(Track);
